@if ({
  emptyCart: emptyCart$ | async,
  }; as content) {
  @if (!content.emptyCart) {
    <form [formGroup]="form">
      <div class="form-group m-0">
        <simple-toggle [checked]="form.get('poLine')?.value" (callbackOnChange)="onChange($event)" label="cart.cartItems.poLine"></simple-toggle>
      </div>
    </form>
  }
}
